// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import releaseVersionEntity from './entities/release-version.json';
import releaseVersionMenu from '../pages/release-version/menu.json';
import releaseVersionFullForm from '../pages/release-version/forms/full.json';
import releaseVersionContextForm from '../pages/release-version/forms/context.json';
import releaseVersionMiniForm from '../pages/release-version/forms/mini.json';
import releaseVersionLookupForm from '../pages/release-version/forms/lookup.json';
import releaseVersionTableView from '../pages/release-version/views/table.json';
import releaseVersionCardsView from '../pages/release-version/views/cards.json';
import releaseVersionCalendarView from '../pages/release-version/views/calendar.json';
import releaseVersionDashboardView from '../pages/release-version/views/dashboard.json';

/** Тип запису «Версія релізу» зі сторінками пакета: меню, форми та подання з pages/release-version/. */
export const releaseVersionDefinition: IRecordTypeDefinition = {
  ...releaseVersionEntity,
  views: assembleViewSet({
      table: releaseVersionTableView,
      cards: releaseVersionCardsView,
      calendar: releaseVersionCalendarView,
      dashboard: releaseVersionDashboardView,
  }),
  form: releaseVersionFullForm,
  forms: { full: releaseVersionFullForm, context: releaseVersionContextForm, mini: releaseVersionMiniForm, lookup: releaseVersionLookupForm },
  menu: releaseVersionMenu,
} as IRecordTypeDefinition;
